import React, { useState } from 'react'


const data = [
	{
		key: 'Is this the right training for me?',
		value: 'Take the test to get feedback on your current situation, your career goals, and necessary milestones.'
	}, {
		key: 'Can I enroll in the program any time?',
		value: (<>Yes, just <a href='https://calendly.com/idiomas-mona-vaccaro' rel='noreferrer' target='_blank' className='underline'>click here</a> and choose your start date.</>)
	}, {
		key: 'Do I need to buy any additional material or course?',
		value: 'No, all material is included in the program, and there is no upsell.'
	}, {
		key: 'How long is the program?',
		value: 'This program lasts 8 weeks. We start with a 4 weeks training phase with 2 x 60 minutes video calls weekly. Then we transition to a 4 weeks mentorship, with 2 x 30 minutes video calls weekly (8 x 60 min).'
	}, {
		key: 'What do I learn in the training?',
		value: 'You will learn how to build your independent tutoring business, define your niche, build your personal brand, create your course content, coaching/teaching methods, tools & templates. Scaling & repurposing, growth strategies, and more. Each training is individual, so topics vary, depending on your personal goals and needs.'
	}, {
		key: 'What happens in the mentorship phase?',
		value: 'We launch your tutoring business and build your students base together, according to the business plan we created in your training. We have 2 weekly 30min video calls to address your questions and optimise your business. You can reach me via email/text any time. I guide you through the process of building and launching your tutoring business, from the very start to the finish line.'
	}, {
		key: 'How much money can I expect to make once my business is up?',
		value: 'This depends on the kind of business you want to build. Every case is different, and you have to put in the work. With this in mind, the lowest we want to hit is 2k€/month before taxes, working part time (20hrs) in 1-2-1 lessons or small groups up to 4 students. On average, 2 months after training we hit the 2k mark. Again, each case is different, some may go for 10k from the start, others are fine with a part time job that makes them 1k or 2k more a month from home.'
	}, {
		key: 'How can I enroll in the program?',
		value: <><a href="https://calendly.com/idiomas-mona-vaccaro/" rel="noreferrer" target="_blank" className="underline">Click here</a></>
	}, {
		key: 'Can I try before buying?',
		value: 'You can book a 1:1 call with me and find out if the program is the right thing for you. Click here to book a 1:1 call'
	}, {
		key: 'I already am a successful independent tutor/coach but I want to scale my business, and have more flexibility. Is there a program for pros?',
		value: 'Yes, of course! We can schedule a call and develop an individual program for your business. You can email me or book a 1:1 call'
	}, {
		key: 'I have been trying to work independently, but it seems I cant find enough students. Does this training really work?',
		value: "Yes, it does. You won't be a millionaire in a year but you will be able to earn a living and scale your income progressively. You learn everything you need to know to build your independent clients base, constantly raise your rates, and stay updated in your industry."
	}, {
		key: 'Do I have to quit my job when I start my tutoring business?',
		value: "No, you can build your tutoring business at your own pace, while working full or part time, or while studying. If you want to focus 100% on building your tutoring career, you need 3 months worth of savings to cover your expenses."
	}, {
		key: 'Is it expensive to build my own independent tutoring business?',
		value: 'The initial costs depend on your starting point and your future business goals. In this program you learn how to up skill, minimise costs, and find the experts you need to help you grow. Everyone has different goals and a different path. Book a 1:1 call to find out what suits your budget best.'
	}, {
		key: 'I am not sure if there is a niche for me, how do I find out?',
		value: <>What is your expertise, and what are you most passionate about? Asking yourself this question is a first step to niche down. <a href="https://calendly.com/idiomas-mona-vaccaro/" rel="noreferrer" target="_blank" className="underline">Click here</a> to book a 1:1 call with me and let's find out what leads you to a successful tutoring business.</>
	}, {
		key: 'What can I teach?',
		value: <>Anything! You can teach languages, sciences, arts, music, sports, nutrition and health, programming, lifestyle and wellbeing, professional gaming, dancing, painting, yoga and meditation, cooking and baking, design, sales skills, finances, social media marketing, writing, and so much more. If there is something you are really good at, and you enjoy sharing, you can teach it. And I can show you how. Book a 1:1 call to find out what your hidden power is. <a href="https://calendly.com/idiomas-mona-vaccaro/" rel="noreferrer" target="_blank" className="underline">Click here</a></>
	}, {
		key: 'Does my location matter when I set my rates?',
		value: 'Yes and no. Your rates are always a reflection of the added value you can provide to your clients. If you live outside the us/can/eu, for competitiveness, you might want to start at a lower rate depending on your target group. But you can scale your business as anyone else. Long term your rates and prices depend on you and the quality of your work entirely'
	}, {
		key: 'I have never worked as a tutor, teacher, or coach. Is this program for me?',
		value: 'My training is the right decision for you if you want to work remotely, be flexible, independent, and make a living with something you love doing and consider yourself to be an expert in. If you are not sure, no worries. Book a 1:1 call with me and we find your niche and the individual plan that works best for you.'
	}, {
		key: 'What is the price for the tutoring program?',
		value: 'Training + mentorship support + material 2.000€. Tutors/coaches on average earn 2k a month 1-3 months after launching, and can start raising their rates and prices.'
	}, {
		key: 'Can I pay in installments?',
		value: "Reach out to me, and let’s see"
	}, {
		key: 'I have more questions, how can I reach you?',
		value: 'Send me an email for questions regarding any course modalities. You can book a 1:1 call if you have questions related to your tutoring/coaching business.'
	}
]

const AccordionSection = ({ items }) => {
	const [activeIndex, setActiveIndex] = useState(null)
	const onTitleClick = (index) => {
		// Toggle the active index, close if the same index is clicked again
		setActiveIndex(activeIndex === index ? null : index)
	}
	const renderIcon = (isOpen) => {
		return isOpen ? (
			<div className="h-6 w-6 rounded-full items-center inline-flex justify-center line-height-6 transform transition ease duration-500 bg-white text-selectiveGreen mb-auto ml-auto" >
				<svg width="8" height="1" viewBox="0 0 8 1" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M8 0V1H0V0H8Z" fill="#19C595"></path>
				</svg>
			</div>
		) : (
			<div className="h-6 w-6 rounded-full items-center inline-flex justify-center line-height-6 transform transition ease duration-500 bg-selectiveGreen text-white mb-auto ml-auto">
				<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M8 3.20755V4.52075H0V3.20755H8ZM4.74549 0V8H3.26253V0H4.74549Z" fill="white"></path>
				</svg>
			</div>
		)

	}

	return (
		<div className="max-w-[740px] w-full mx-auto">
			{items.map((item, index) => (
				<div key={index} className={`mb-2 overflow-hidden ${activeIndex === index ? 'rounded-[24px]' : 'rounded-0 border-b-[0.5px] border-solid border-jet'}`}>
					<div
						onClick={() => onTitleClick(index)}
						className={`cursor-pointer p-4 flex justify-between items-center ${activeIndex === index ? 'bg-selectiveGreen text-white' : 'bg-white text-jet'} rounded-t-[24px] w-full transition-colors duration-300`}
					>
						{item.key}
						<div className="w-6 h-6 flex items-center justify-center">
							{renderIcon(activeIndex === index)}
						</div>
					</div>
					<div
						className={`transition-all duration-300 overflow-hidden ${activeIndex === index ? 'max-h-96 bg-selectiveGreen rounded-b-[24px] py-4' : 'max-h-0'} px-4 text-white`}
						style={{ backgroundColor: activeIndex === index ? '#19C595' : undefined }}
					>
						{activeIndex === index ? item.value : null}
					</div>
				</div>
			))}
		</div>
	)
}


const FAQ = () => {
	return (
		<section className="py-16 mt-32">
			<div className="container px-4">
				<div className="flex w-full justify-center mb-14">
					<div className="max-w-[550px]">
						<h2 className="text-[32px] text-jet font-semibold text-center mb-4">
							FAQ
						</h2>
						<p className="text-base text-jet font-normal text-center">
							Dive into our FAQs for insights, advice, and the support you need to accelerate your vision into reality.
						</p>
					</div>
				</div>
				<div className="grid gap-6 justify-center overflow-hidden">

					<AccordionSection items={data} />

					<div className="group outline-none accordion-section max-w-[740px] w-full flex flex-wrap justify-center" tabIndex="19">
						<div className="group-focus:bg-selectiveGreen bg-white p-4 rounded-t-[24px] group-focus:rounded-b-[24px] w-full border-b-[0.5px] border-solid border-jet group-focus:border-none">
							<div className="group w-full flex justify-between items-center transition ease duration-500 cursor-pointer relative pr-10">
								<div className="text-base font-medium text-jet group-focus:text-white">
									I have more questions, how can I reach you? </div>
								<div
									className="h-6 w-6 rounded-full items-center inline-flex justify-center transform transition ease duration-500 bg-selectiveGreen group-focus:bg-white absolute top-0 right-0 mb-auto ml-auto">
									<svg className="group-focus:hidden" width="8" height="8" viewBox="0 0 8 8" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M8 3.20755V4.52075H0V3.20755H8ZM4.74549 0V8H3.26253V0H4.74549Z" fill="white">
										</path>
									</svg>
									<svg className="hidden group-focus:block" width="8" height="1" viewBox="0 0 8 1" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M8 0V1H0V0H8Z" fill="#19C595"></path>
									</svg>

								</div>
							</div>
							<div className="group-focus:max-h-screen max-h-0 w-full overflow-hidden ease duration-500">
								<p className="group-focus:text-white text-jet text-sm w-full mt-4">
									Send me an email for questions regarding any course modalities. You can book a 1:1 call if
									you have questions related to your tutoring/coaching business.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default FAQ